import { StockOrderType } from "./stock-order.model";
import { OrderOriginTypeEnum } from "../../enum/orders/origin-type.enum";

/** Modelo para envio de ordem planejada (checkout planejado) */
export class StrategyRequest {
    constructor(
        public symbol: string,
        public isDayTrade: boolean,
        public researchID: number,
        public originType: OrderOriginTypeEnum,
        public legs: Array<StockOrderType>,
        public id: string = null,
        public suitabilityNonConformityConsent?: boolean
    ) {}
}
